module.exports = __webpack_public_path__ + "static/img/logo.fde08b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/logo.png
// module id = 0Er0
// module chunks = 1